import { render, staticRenderFns } from "./Dashboard_Info.new2.vue?vue&type=template&id=3ec73076&scoped=true&"
import script from "./Dashboard_Info.new2.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Info.new2.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Info.new2.vue?vue&type=style&index=0&id=3ec73076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec73076",
  null
  
)

export default component.exports